import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import {
  Box, Button, Card, Paper, Stack, TextField, Typography, Drawer, Autocomplete
} from '@mui/material';
import './DoctorNotes.css';
import RestAPIService from '../../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../../Utility/API/Serviceurls';
import { getCachevalue, localGetItem } from '../../../../../Utility/Services/CacheProviderService';
import { CommonPatientCard, CommonPatientDetails, ConsultantPatientCard } from '../../../../../Components/Common Components/CommonComponents';
import { Colors } from '../../../../../Styles/Colors';
import '../IpPatientDetails.css'
import ToastMsg from '../../../../../Components/ToastMsg/ToastMsg';
import { CheckAccessFunc, renderCorpInsuranceCard } from '../../../../../Components/CommonFunctions/CommonFunctions';
import { ImagePaths } from '../../../../../Utility/ImagePaths';
import { DateTime } from 'luxon';
import { Ip_Doc_PRINT_DEFAULT } from '../../../../../Utility/Constants';
import SarasWriteNotes from './DocNotesComponents/SarasWriteNotes';

class ProgressiveNotes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ipPatientData: {},
      IPadmissionDetails: {},
      CallGetComponent: "",
      EditSymptomsData: {},
      EditExaminationsData: {},
      EditProvDiagnosisData: "",
      withOutAppointment: {},
      clinic_id: JSON.parse(localGetItem('SelectedDoctorClinicId')),
      isNotesClrClked: false,
      isNotesSaveClked: false,
      isWriteNotes: false,
      // filter
      write_notes_txt: {},
      write_notes: [],
      patientPrimType: {},
      showNewDocNotes: false,
      ipDoctorNotesLayout:{},
      HistoryList: [],
    }
  }

  fetchData = () => {
    this.getPatientData();
    this.getNotesData();
    this.getPatientPrimaryData();
    this.getProgressiveHistory()
  }

  componentDidMount() {
    let ipPatientData = getCachevalue("IppatientData")
    let patientData = JSON.parse(ipPatientData)
    let appointmentDetail = getCachevalue("withoutAppointment");
    let showNewDocNotes = JSON.parse(localGetItem('loggedInUserInfo'))
    this.setState({ showNewDocNotes: showNewDocNotes?.new_doctor_notes_template_others }, () => {
      const currentDate = new Date();
      const admissionDate = patientData?.admission_date ? new Date(patientData.admission_date) : currentDate;
      let dischargeDate = patientData?.discharge_date ? new Date(patientData.discharge_date) : currentDate;

      // Ensure discharge date is not in the future
      if (dischargeDate > currentDate) {
        dischargeDate = currentDate;
      }

      // Format the dates
      const formattedAdmissionDate = DateTime.fromJSDate(admissionDate).toFormat('yyyy-MM-dd');
      const formattedDischargeDate = DateTime.fromJSDate(dischargeDate).toFormat('yyyy-MM-dd');

      let details = JSON.parse(appointmentDetail);
      const newState = {
        ipPatientData: patientData,
        fromDate: formattedAdmissionDate,
        toDate: formattedDischargeDate
      };

      if (details?.patient_id === patientData?.patient_id) {
        newState.withOutAppointment = details;
      }

      this.setState(newState, () => {
        this.fetchData();
      });
    })
  }

    getProgressiveHistory() {
        try {
        let admission_id = this.state.ipPatientData?.id || this.state.withOutAppointment?.ip_admission_id;
        RestAPIService.getAll(Serviceurls.SAR_IP_DOC_PROGRESSIVE_NOTES_HISTORY + `?ip_admission_id=${admission_id}`).
            then((response) => {
            if (response.data.status === "success") {
                let listData =response.data.data ? response.data.data : []
                this.setState({
                HistoryList: listData
                })
            }
            else {
                this.errorMessage(response.data.message)
            }
            }).catch((e) => {
            this.errorMessage(e.message)
            })
        }
        catch (e) {
        this.errorMessage(e.message)
        }
    }
    
  getPatientData = () => {
    let admission_id = this.state.ipPatientData?.id || this.state.withOutAppointment?.ip_admission_id;
    let url = `${(localGetItem('isNewBilling') === "false" ? Serviceurls.IP_PATIENT_DETAILS : Serviceurls.IP_PATIENT_DETAILS_NEW)}?admission_id=${admission_id}`;
    if (this.props.is_From_IpNotes && this.state.clinic_id) {
      url = `${url}&clinic_id=${this.state.clinic_id}`
    }
    try {
      RestAPIService.getAll(url)
        .then((response) => {
          if (response.data.status === "success") {
            this.setState({
              IPadmissionDetails: response.data.data[0]
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getPatientPrimaryData = () => {
    try {
      const admission_id = this.state.ipPatientData?.id || this.state.withOutAppointment?.ip_admission_id;
      RestAPIService.getAll(Serviceurls.DOC_PATIENT_PRIMARY_PAYMENT_GET + "?ip_admission_id=" + admission_id)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              patientPrimType: response?.data?.data
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getNotesData() {
    let admission_id = this.state.ipPatientData?.id || this.state.withOutAppointment?.ip_admission_id;
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    let login_doctor_id = myUser?.doctor_id;
    try {
      RestAPIService.getAll(Serviceurls.IP_DOC_WRITE_NOTES + "?ip_admission_id=" + admission_id).
        then((response) => {
          if (response.data.status === "success") {
            let data = response.data.data?.length > 0 ? response.data.data : [];
            let result = data.reduce((acc, cur) => {
              const assignNote = (key) => {
                if (cur[key]) {
                  const note = {
                    id: cur.id,
                    notes: cur[key],
                    doctor_id: cur.doctor_id,
                    doctor__photo_url: cur.doctor__photo_url,
                    doctor_speciality: cur.doctor_speciality,
                    doctor_name: cur.doctor_name,
                    date: cur.date
                  };
                  const check_doc_id = this.props.is_From_IpNotes ? (cur?.doctor_id === login_doctor_id)
                    : (cur?.doctor_id === this.state.ipPatientData?.doctor_id);
                  if (check_doc_id) {
                    acc[`${key}_txt`] = note;
                  } else {
                    acc[key].push(note);
                  }
                }
              };

              assignNote('write_notes');
              assignNote('discharge_notes');
              assignNote('family_counselling');
              assignNote('instructions');

              return acc;
            }, {
              write_notes_txt: {},
              write_notes: [],
              discharge_notes_txt: {},
              discharge_notes: [],
              family_counselling_txt: {},
              family_counselling: [],
              instructions_txt: {},
              instructions: [],
            });

            this.setState({
              write_notes_txt: result.write_notes_txt,
              write_notes: result.write_notes,
              discharge_notes_txt: result.discharge_notes_txt,
              discharge_notes: result.discharge_notes,
              family_counselling_txt: result.family_counselling_txt,
              family_counselling: result.family_counselling,
              instructions_txt: result.instructions_txt,
              instructions: result.instructions,
            })
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  TriggerGetApi(component) {
    this.setState({
      CallGetComponent: component
    }, () => {
      setTimeout(() => { this.setState({ CallGetComponent: "" }) }, 500)
    })
  }

  TriggerGetApis() {
    this.setState({
      triggerApis: "triggerApiCalls"
    }, () => {
      setTimeout(() => { this.setState({ triggerApis: "" }) }, 500)
    })
  }

  EditSymptomData(data) {
    this.setState({
      EditSymptomsData: data
    })
  }
  ClearPropsData() {
    this.setState({
      EditSymptomsData: {},
      EditExaminationsData: {},
      EditProvDiagnosisData: "",
    })
  }

  handleSaveClick = () => {
    this.setState({
      isNotesSaveClked: false,
      isNotesClrClked: false,
      CallGetComponent: ""
    });
  };

  getDoctorNotesPrint = () => {
    let admission_id = this.state.ipPatientData?.id || this.state.withOutAppointment?.ip_admission_id;
    let doctorId = this.state.ipPatientData?.doctor_id;

    const from_date = DateTime.fromJSDate(new Date(this.state.fromDate)).toFormat('yyyy-MM-dd');
    const to_date = DateTime.fromJSDate(new Date(this.state.toDate)).toFormat('yyyy-MM-dd');

    let url = `${Serviceurls.IP_DOCTOR_NOTES_PRINT}?ip_admission_id=${admission_id}&doctor_notes=Write Notes&from_date=${from_date || null}&to_date=${to_date || null}`
    if (this.props.is_From_IpNotes && this.state.clinic_id) {
      url = `${url}&clinic_id=${this.state.clinic_id}`
    } else {
      url = `${url}&doctor_id=${doctorId}`
    }
    try {
      RestAPIService.getAllPrint(url)
        .then((response) => {
          if (response) {
            //Create a Blob from the PDF Stream
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' });
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            //Open the URL on new Window
            window.open(fileURL);
          }
        }).catch((error) => {
          if (error?.response?.data?.status === 'fail') {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
  // doctor notes print ends

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
    })
  }

  render() {
    const { t } = this.props
    var { ipPatientData } = this.state
    let attender = {
      lineOne: t("AttenderName"),
      lineTwo: `${ipPatientData.attender_name != null ? ipPatientData.attender_name : '-'}`,
      lineFour: t('ContactNumber'),
      LineFive: `${ipPatientData.attender_mobile != null ? ipPatientData.attender_mobile : '-'}`
    }
    let consultant = {
      lineOne: t("ConsultantName"),
      lineTwo: `${ipPatientData.doctor_name != null ? ipPatientData.doctor_name : '-'}`,
    }
    const checkuserAccess = this.props.is_From_IpNotes ? false :
      CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Doctor Notes", "SubTab")?.editAccess ?
        this.state.withOutAppointment?.is_ip : true;
    const changeWidth = (this.props.is_From_IpNotes && (this.state.patientPrimType?.insurance_company_name || this.state.patientPrimType?.employer_name));
    return (
      <Box sx={{ backgroundColor: Colors.ComponentBgColor }}>
        <Box component={'div'} marginLeft={'0.5dvw'} marginBottom={"0.3dvw"} display={'flex'} justifyContent="space-between" alignItems='center' className='eMed_patient_header'>
          <Box display={'flex'} alignItems='center'>
            <Box className='eMed_Patient_Details_Long eMed_patient_box'>
              <CommonPatientDetails data={this.state.ipPatientData} showDetailed={true} />
            </Box>
            <CommonPatientCard details={attender} width={changeWidth ? "20vw" : ""} showDetailed={true} toolLen={18} />
            <ConsultantPatientCard name={consultant} width={changeWidth ? "16dvw" : "20dvw"} showTooltip={true} />
            {this.props.is_From_IpNotes && (this.state.patientPrimType?.insurance_company_name ? renderCorpInsuranceCard("Insurance Details", this.state.patientPrimType?.insurance_company_name, "13dvw")
              : this.state.patientPrimType?.employer_name ? renderCorpInsuranceCard("Corporate Details", this.state.patientPrimType?.employer_name, "13dvw") : null)}
          </Box>
         <Box className="eMed_WrtNotes_lblCont">
            <Button className='eMed_usrconf_btn' size="small"
              sx={{ position: "relative" }}
              onClick={ () => {
                this.getDoctorNotesPrint() }
              }
              emed_tid="progressive_notes_print_btn">
              <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
            </Button>
          </Box>
        </Box>
          <Card className='eMed_DocNotes_Left_Main' sx={{ width: "100%", overflowY: 'auto !important' }}>
            <SarasWriteNotes
              key={"isWriteNotes"}
              IpPatientData={this.state.ipPatientData}
              CallgetApi={this.getNotesData.bind(this)}
              IPadmissionDetails={this.state.IPadmissionDetails}
              withOutAppointment={this.state.withOutAppointment}
              is_From_IpNotes={this.props.is_From_IpNotes}
              label={"Doctor Notes"}
              placeholder={"Write progressive notes here"}
              rowlength={4}
              doctorsData={this.state.write_notes}
              doctorTxt={this.state.write_notes_txt}
              isClearClked={this.state.CallGetComponent === 'isWriteNotes' && this.state.isNotesClrClked}
              isSaveClked={this.state.CallGetComponent === 'isWriteNotes' && this.state.isNotesSaveClked}
              onSaveComplete={this.handleSaveClick}
              checkuserAccess={checkuserAccess}
              HistoryList={this.state.HistoryList}
              callhistoryApi={this.getProgressiveHistory.bind(this)}
            />
          </Card>
          {
          this.state.isErrorMsg ?
            <ToastMsg
              severity={"error"}
              msg={this.state.isErrorMsgText}
              msgPop={this.msgClose.bind(this)}
            /> : null
        }
      </Box>
    )
  }
}
export default withTranslation()(ProgressiveNotes)
